import { matchPath } from "react-router";

export const Paths = {
    _PATH: "/",
    Table: {
        _PATH: "/table",
        JOIN: "/table/:code",
        TABLE: "/table/:code/:playerKey"
    }
    // Account: {
    //     _PATH: "/account",
    //     LOGIN: "/account/login",
}

export function openRoute(history, path, ...params)
{
    history.push(getPath(path, ...params))
}

export function replaceRoute(history, path, ...params)
{
    history.replace(getPath(path, ...params))
}

export function getPath(path, ...params)
{
    let paramsIdx = 0
    return path.split("/").map(s => s.startsWith(":") ? params[paramsIdx++] : s).join("/")
}

export function goBack(history)
{
    if (history.length === 1) // The user just pasted the link, nowhere to go back to
    {
        openRoute(history, Paths._PATH)
    }
    else
    {
        history.goBack()
    }
}

export function matches(location, path, exact)
{
    return !!matchPath(location.pathname, { path: path, exact: exact, strict: false })
}

/**
 * Select the matching route like (most exact routes should come first):
 * selectMatch(this.props.location, { "/test": "test", "/": "Home" })
 */
export function selectMatch(location, config)
{
    const e = Object.entries(config)
        .find(e => matches(location, e[0], false))
    return e ? e[1] : null
}

export default Paths